import React, { createContext, useMemo } from "react";
import { toast } from "react-toastify";
import AxiosService from "services/Axios";

const FortunePremiumContext = createContext();

const FortunePremiumProvider = ({ children }) => {
  const getAllPremiumReports = async () => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/premium-reports`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const getNameFortunePremiumNumbersResult = async (reportId) => {
    try {
      return await AxiosService.put(`${process.env.REACT_APP_API_URL}/user/fortune/name/premium/result/${reportId}`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const buyFortunePremium = async (testType, payload) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/premium/buy/${testType}`, payload);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const buyExtendedDailySubCategoryFortunePremium = async (testType, payload) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/premium/buy/daily-category/${testType}`, payload);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const getNameFortunePremiumNumbers = async (reportId, formData) => {
    try {
      return await AxiosService.put(`${process.env.REACT_APP_API_URL}/user/fortune/name/premium/code/${reportId}`, formData);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const createPremiumRealEstateFortune = async (id, type, payload) => {
    try {
      return await AxiosService.post(
        `${process.env.REACT_APP_API_URL}/user/fortune/real-estate/premium/${type}/${id}`,
        payload,
      );
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const getPremiumRealEstateFortuneById = async (id) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/real-estate/premium/${id}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getRealEstateBusinessList = async () => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/real-estate-business/list`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const createPremiumRealEstateBusinessFortune = async (id, payload) => {
    try {
      return await AxiosService.post(
        `${process.env.REACT_APP_API_URL}/user/fortune/real-estate-business-fit/premium/${id}`,
        payload,
      );
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
    }
  };

  const getPremiumRealEstateBusinessFortuneById = async (id) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/real-estate-business-fit/premium/${id}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumDailyFortuneById = async (id, date) => {
    try {
      const baseUrl = `${process.env.REACT_APP_API_URL}/user/fortune/daily/premium/${id}`;
      return await AxiosService.get(date ? `${baseUrl}?date=${date}` : baseUrl);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumExtendedDailyFortuneList = async (startDate, endDate) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/daily/premium-tests?startDate=${startDate}&endDate=${endDate}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getDailyCalendarStatusList = async (startDate, endDate) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/daily/calendar?startDate=${startDate}&endDate=${endDate}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const validateDailyFortuneDate = async (formData) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/daily/validate-date`, formData);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getMarriageCalendarStatusList = async (startDate, endDate) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/marriage/calendar?startDate=${startDate}&endDate=${endDate}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumMarriageFortuneById = async (id, body) => {
    try {
      const baseUrl = `${process.env.REACT_APP_API_URL}/user/fortune/marriage/premium/${id}`;
      return await AxiosService.post(baseUrl, body);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumMarriageFortuneList = async (startDate, endDate) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/marriage/premium-tests?startDate=${startDate}&endDate=${endDate}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumMarriageMonthSelectionListList = async () => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/marriage/selection/months/list`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getBasicTotalFortuneById = async (reportId) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/total/basic/${reportId}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumTotalFortuneSummaryById = async (reportId, payload) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/total/premium/${reportId}/summary`, payload);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getPremiumTotalFortuneReportById = async (reportId, payload) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/total/premium/${reportId}`, payload);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const validateTotalFortuneDate = async (formData) => AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/total/validate-date`, formData);

  const validateDeepAnalysisDate = async (domain, formData) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/total/deep-analysis/${domain}/validate-date`, formData);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  const getReportById = async (reportId) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/report/${reportId}`);
    } catch (error) {
      // toast.error('데이터를 불러오는데 오류가 발생했습니다.', error);
    }
  };

  // 재물운/직업운/연애운 심층 분석 리포트의 파트별(A/B/C) 콘텐츠 조회.
  // 실패를 조용히 삼키는 이유: 호출부(각 DetailedReport의 callGroup)가 파트 단위로
  // 자체 재시도·에러 카드 UI를 이미 갖고 있어, 여기서 또 toast를 띄우면 중복 알림이 된다.
  const getDeepAnalysisReportPart = async (domain, part, formData) => {
    try {
      return await AxiosService.post(`${process.env.REACT_APP_API_URL}/user/fortune/total/deep-analysis/${domain}/${part}`, formData);
    } catch (error) {
      // no-op: caller handles retry/error UI
    }
  };

  const getGoodBadNameChars = async (id) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/fortune/total/deep-analysis/name-chars/${id}`);
    } catch (error) {
      // no-op: caller handles retry/error UI
    }
  };

  const value = useMemo(
    () => ({
      getAllPremiumReports,
      getNameFortunePremiumNumbersResult,
      getNameFortunePremiumNumbers,
      createPremiumRealEstateFortune,
      getPremiumRealEstateFortuneById,
      getRealEstateBusinessList,
      createPremiumRealEstateBusinessFortune,
      getPremiumRealEstateBusinessFortuneById,
      getPremiumDailyFortuneById,
      getPremiumExtendedDailyFortuneList,
      buyFortunePremium,
      buyExtendedDailySubCategoryFortunePremium,
      getDailyCalendarStatusList,
      validateDailyFortuneDate,
      getPremiumMarriageFortuneById,
      getPremiumMarriageFortuneList,
      getMarriageCalendarStatusList,
      getPremiumMarriageMonthSelectionListList,
      getBasicTotalFortuneById,
      getPremiumTotalFortuneSummaryById,
      getPremiumTotalFortuneReportById,
      validateTotalFortuneDate,
      validateDeepAnalysisDate,
      getDeepAnalysisReportPart,
      getReportById,
      getGoodBadNameChars,
    }),
    [
      getAllPremiumReports,
      getNameFortunePremiumNumbersResult,
      getNameFortunePremiumNumbers,
      createPremiumRealEstateFortune,
      getPremiumRealEstateFortuneById,
      getRealEstateBusinessList,
      createPremiumRealEstateBusinessFortune,
      getPremiumRealEstateBusinessFortuneById,
      getPremiumDailyFortuneById,
      getPremiumExtendedDailyFortuneList,
      buyFortunePremium,
      buyExtendedDailySubCategoryFortunePremium,
      getDailyCalendarStatusList,
      validateDailyFortuneDate,
      getPremiumMarriageFortuneById,
      getPremiumMarriageFortuneList,
      getMarriageCalendarStatusList,
      getPremiumMarriageMonthSelectionListList,
      getBasicTotalFortuneById,
      getPremiumTotalFortuneSummaryById,
      getPremiumTotalFortuneReportById,
      validateTotalFortuneDate,
      validateDeepAnalysisDate,
      getDeepAnalysisReportPart,
      getGoodBadNameChars,
    ],
  );

  return (
    <FortunePremiumContext.Provider value={value}>
      {children}
    </FortunePremiumContext.Provider>
  );
};

export { FortunePremiumContext, FortunePremiumProvider };
